import React, { useEffect } from 'react';
import Providers from './Providers';
import AppRouter from './router';
import { useThemeParams, useWebApp } from '@vkruglikov/react-telegram-web-app';

export default function App() {
	const WebApp = useWebApp();
	const [colorScheme, themeParams] = useThemeParams();

	useEffect(() => {
		WebApp.setHeaderColor('secondary_bg_color')
		WebApp.setBackgroundColor('secondary_bg_color')
		document.body.classList.add('theme-' + (colorScheme !== 'dark' ? 'dark' : 'dark'));
	}, [WebApp, colorScheme]);

	return (
		<Providers>
			<AppRouter />
		</Providers>
	);
};
